import React from 'react'
import { graphql } from 'gatsby'
import { Buttons, LinkButton } from '../../components/button'
import { DiscordIcon } from '../../components/icons'
import {
  Container,
  Intro,
  Title,
  Section,
  Background,
} from '../../components/page'

import * as styles from './ambassadors-more.module.scss'

export type AmbassadorsMoreProps = Queries.AmbassadorsMoreFragment

export const AmbassadorsMore = ({
  title,
  text,
  buttons,
}: AmbassadorsMoreProps) => {
  return (
    <Section className={styles.section} variant="ambassadorsmore">
      <Container>
        <div>
          <Title color="light" center>
            {title}
          </Title>
          <Intro color="light" center narrow>
            {text?.text}
          </Intro>
        </div>
        <Buttons center>
          {buttons?.map((item, index) => (
            <LinkButton
              key={item?.id}
              color={index === 0 ? 'primary' : 'secondary'}
              variant={index === 0 ? 'fill' : null}
              link={item}
            >
              <DiscordIcon />
              {item?.title}
            </LinkButton>
          ))}
        </Buttons>
      </Container>
      <Background variant="ambassadorsmore" />
    </Section>
  )
}

export const AmbassadorsMoreFragments = graphql`
  fragment AmbassadorsMore on ContentfulAmbassadorsMore {
    __typename
    id
    title
    text {
      text
    }
    buttons {
      ...Link
    }
  }
`
